import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { getSites } from 'src/api/siteApi';

export type AdminSite = { id: string; code?: string | null; displayName?: string | null };

// Rows from before multi-site have no site and belong to Nonprofit Trips.
export const resolveSiteName = (sites: AdminSite[], siteId?: string | null): string => {
   const site = siteId ? sites.find(s => s.id === siteId) : sites.find(s => s.code === 'NPT');
   return site?.displayName ?? site?.code ?? '';
};

/**
 * Every site, for the admin lists' Site column and Site filter (NPT-2096). Shares the
 * ['getSites'] cache with the site config registry.
 */
export const useAdminSites = () => {
   const { data } = useQuery({
      queryKey: ['getSites'],
      queryFn: () => getSites({}),
      staleTime: 5 * 60 * 1000,
   });

   const sites: AdminSite[] = useMemo(() => data?.data?.entities ?? [], [data]);

   const siteName = useCallback((siteId?: string | null) => resolveSiteName(sites, siteId), [sites]);

   return { sites, siteName };
};
